import React, { useEffect, useId, useRef, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// Keep help available to mouse and keyboard users, including while reading it.
export default function ActionTooltip({ children, description }) {
  const id = useId();
  const [show, setShow] = useState(false);
  const reading = useRef(false);

  useEffect(() => {
    if (!show) return undefined;
    const dismiss = (event) => {
      if (event.key === 'Escape') {
        reading.current = false;
        setShow(false);
      }
    };
    document.addEventListener('keydown', dismiss);
    return () => document.removeEventListener('keydown', dismiss);
  }, [show]);

  return (
    <OverlayTrigger
      placement="top"
      flip
      show={show}
      onToggle={(next) => { if (next || !reading.current) setShow(next); }}
      delay={{ show: 150, hide: 150 }}
      overlay={
        <Tooltip
          id={id}
          className="manage-action-tooltip"
          onMouseEnter={() => { reading.current = true; setShow(true); }}
          onMouseLeave={() => { reading.current = false; setShow(false); }}
        >
          {description}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
}
